/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/08/22
 */

import React from 'react';
import { useWorkplanSummary } from '@/components/contexts/WorkplanSummaryContext/useWorkplanSummary';
import LeaveTile from '@/components/pages/dashboard/tiles/LeaveTile/LeaveTile';

const WorkplanLeaveTile = () => {
    const { workplanSummary, loading, error } = useWorkplanSummary();
    return <LeaveTile values={workplanSummary?.counts} loading={loading} error={!!error} />;
};

export default WorkplanLeaveTile;
